import { Routes } from '@angular/router';
import { Login } from './core/auth/login/login';
import { Home } from './core/home/home';
import { veselResolver } from './resolvers/vesel-resolver-resolver';
import { engineResolver } from './resolvers/engine-resolver';
import { manualResolver } from './resolvers/manual-resolver';
import { companyResolver } from './resolvers/company-resolver';
import { maintenanceResolver } from './resolvers/maintenance-resolver';
import { permissionsGuard } from './guards/permissions-guard';
import { equipoResolver } from './resolvers/equipo-resolver';

export const routes: Routes = [
	{ path: '', pathMatch: 'full', redirectTo: '/login' },
	{
		path: 'forgotPassword',
			loadComponent: () => import('./core/auth/reset-password/reset-password').then(m => m.ResetPassword)
	},
	{
		path: 'resetpassword/:email',
			loadComponent: () => import('./core/auth/forgot-password/forgot-password').then(m => m.ForgotPassword)
	},

	{ path: '', component: Home, children: [
		{ path: 'vessels', pathMatch: 'full', 
			redirectTo: 'vessels', data: { permission: 'flota' }},
		{ path: 'vessels',
			canActivate: [permissionsGuard],
			 loadComponent: () => import('./features/vesels/vesel-home/vesel-home').then(m => m.VeselHome),
			 		data: {  headerTitle: 'titles.vessels', permission: 'flota' }
			},
		{
			path: 'vessels/detail/:imo',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/vesels/vesel-detail/vesel-detail').then(m => m.VeselDetail),
			resolve: {
				vessel: veselResolver
			},
			data: {  headerTitle: 'titles.vessels_detail', permission: 'flota' }
		},
		{
			path: 'vessels/edit/:imo',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/vesels/vesel-edit/vesel-edit').then(m => m.VeselEdit),
			resolve: {
				vessel: veselResolver
			},
			data: {  headerTitle: 'titles.vessels_edit', permission: 'flota' }
		},
		{
			path: 'vessels/new',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/vesels/vesel-form/vesel-form').then(m => m.VeselForm),
			data: {  headerTitle: 'titles.vessels_new', permission: 'flota' }
		},
		
		// engine routes
		{path: 'engines',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/engines/engine-home/engine-home').then(m => m.EngineHome),
			data: {  headerTitle: 'titles.engines', permission: 'motores' }
		},
		{
			path: 'engines/detail/:id',
			canActivate: [permissionsGuard],
			resolve: {
				engine: engineResolver
			},
			loadComponent: () => import('./features/engines/engine-detail/engine-detail').then(m => m.EngineDetail),
			data: {  headerTitle: 'titles.engines_detail', permission: 'motores' }
		},
		{path: 'engines/new',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/engines/engine-form/engine-form').then(m => m.EngineForm),
			data: {  headerTitle: 'titles.engines_new', permission: 'motores' }
		},
		{
			path: 'engines/edit/:id',
			resolve: {
				engine: engineResolver
			},
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/engines/engine-edit/engine-edit').then(m => m.EngineEdit),
			data: {  headerTitle: 'titles.engines_edit', permission: 'motores' }
		},
		// manuals routes

		{path: 'manuals',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/manuals/manual-home/manual-home').then(m => m.ManualHome),
			data: {  headerTitle: 'titles.manuals', permission: 'manuales' }
		},
		{
			path: 'manuals/processing-issues',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/manuals/processing-issues/processing-issues').then(m => m.ProcessingIssues),
			data: {  headerTitle: 'titles.processing_issues', permission: 'manuales' }
		},
		{
			path: 'manuals/:manualId/processing-issues',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/manuals/processing-issues/processing-issues').then(m => m.ProcessingIssues),
			data: {  headerTitle: 'titles.processing_issues', permission: 'manuales' }
		},
		{
			path: 'manuals/detail/:id',
			resolve: {
				manual: manualResolver
			},
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/manuals/manual-viewer/manual-viewer-container/manual-viewer-container').then(m => m.ManualViewerContainer),
			data: {  headerTitle: 'titles.manual_detail', permission: 'manuales' }
		},
		{
			path: 'manuals/:manualId/parts',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/manuals/manual-fix-part/manual-fix-part').then(m => m.ManualFixPart),
			data: {  headerTitle: 'manuals.consult_parts', permission: 'manuales' }
		},

		// engine-piece routes
		{path: 'engine-pieces',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/engine-part/engine-part-home/engine-part-home').then(m => m.EnginePartHome),
			data: {  headerTitle: 'titles.engine_parts', permission: 'componentes' }
		},
		// equipos routes
		{path: 'equipos',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/equipos/equipos-home/equipos-home').then(m => m.EquiposHome),
			data: {  headerTitle: 'titles.equipment', permission: 'equipos' }
		},
		{
			path: 'equipos/detail/:id',
			canActivate: [permissionsGuard],
			resolve: {
				equipo: equipoResolver
			},
			loadComponent: () => import('./features/equipos/equipo-detail/equipo-detail').then(m => m.EquipoDetail),
			data: {  headerTitle: 'titles.equipos_detail', permission: 'equipos' }
		},
		{path: 'equipos/new',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/equipos/equipo-form/equipo-form').then(m => m.EquipoForm),
			data: {  headerTitle: 'titles.equipos_new', permission: 'equipos' }
		},
		{
			path: 'equipos/edit/:id',
			resolve: {
				equipo: equipoResolver
			},
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/equipos/equipo-edit/equipo-edit').then(m => m.EquipoEdit),
			data: {  headerTitle: 'titles.equipos_edit', permission: 'equipos' }
		},

		// companies routes
		{path: 'companies',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/companies/company-home/company-home').then(m => m.CompanyHome),
			data: {  headerTitle: 'titles.companies', permission: 'empresas' }
		},
		{
			path: 'companies/detail/:id',
			resolve: {
				company: companyResolver
			},
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/companies/company-detail/company-detail').then(m => m.CompanyDetail),
			data: {  headerTitle: 'titles.company_detail', permission: 'empresas' }
		},
		{
			path: 'companies/new',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/companies/company-form/company-form').then(m => m.CompanyForm),
			data: {  headerTitle: 'titles.company_new', permission: 'empresas' }
		},
		{
			path: 'companies/edit/:id',
			resolve: {
				company: companyResolver
			},
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/companies/company-edit/company-edit').then(m => m.CompanyEdit),
			data: {  headerTitle: 'titles.company_edit', permission: 'empresas' }
		},
		{
			path: 'companies/users/signup',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/users/signup/signup').then(m => m.Signup),
			data: { headerTitle: 'titles.signup_user', permission: 'empresas' }
		},
		{
			path: 'companies/users/detail/:id',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/users/user-detail/user-detail').then(m => m.UserDetail),
			data: { headerTitle: 'titles.user_detail', permission: 'empresas' }
		},
		{
			path: 'companies/users/edit/:id',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/users/user-edit/user-edit').then(m => m.UserEdit),
			data: { headerTitle: 'titles.user_edit', permission: 'empresas' }
		},
		{
			path: 'companies/users',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/users/user-home/user-home').then(m => m.UserHome),
			data: { headerTitle: 'titles.users', permission: 'empresas' }
		},
		// part-lists routes
		{
			path: 'part-lists',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/part-lists/part-list-home/part-list-home').then(m => m.PartListHome),
			data: { headerTitle: 'titles.part_lists', permission: 'documentos' }
		},
		{
			path: 'part-lists/detail/:id',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/part-lists/part-list-detail/part-list-detail').then(m => m.PartListDetail),
			data: { headerTitle: 'titles.part_list_detail', permission: 'documentos' }
		},
		{
			path: 'part-lists/edit/:id',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/part-lists/part-list-edit/part-list-edit').then(m => m.PartListEdit),
			data: { headerTitle: 'titles.part_list_edit', permission: 'documentos' }
		},
		// maintenances routes
		{
			path: 'maintenances',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/maintenances/maintenance-home/maintenance-home').then(m => m.MaintenanceHome),
			data: { headerTitle: 'titles.maintenances', permission: 'mantenimientos' }
		},
		{
			path: 'maintenances/create',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/maintenances/maintenance-edit/maintenance-edit').then(m => m.MaintenanceEdit),
			data: { headerTitle: 'titles.maintenance_new', permission: 'mantenimientos' }
		},
		{
			path: 'maintenances/edit/:id',
			resolve: {
				maintenance: maintenanceResolver
			},
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/maintenances/maintenance-edit/maintenance-edit').then(m => m.MaintenanceEdit),
			data: { headerTitle: 'titles.maintenance_edit', permission: 'mantenimientos' }
		},
		{
			path: 'maintenances/detail/:id',
			resolve: {
				maintenance: maintenanceResolver
			},
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/maintenances/maintenance-detail/maintenance-detail').then(m => m.MaintenanceDetail),
			data: { headerTitle: 'titles.maintenance_detail', permission: 'mantenimientos' }
		},
		{
			path: 'chatbot',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/chatbot/chatbot-main/chatbot-main').then(m => m.ChatbotMainComponent),
			data: { headerTitle: 'titles.ia_assistant', permission: 'leo' }
		},
		{
			path: 'help',
			canActivate: [permissionsGuard],
			loadComponent: () => import('./features/help/help-home/help-home').then(m => m.HelpHome),
			data: { headerTitle: 'titles.help', permission: 'ayuda' }
		},
		{
			path: 'profile',
			loadComponent: () => import('./features/profile/profile-home/profile-home').then(m => m.ProfileHome),
			data: { headerTitle: 'titles.profile' }
		},
	]},

	{ path: 'login', component: Login },
	{ path: '**', redirectTo: '/login' },
];
